var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank Cards") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M47.6 29H4.4A2.4 2.4 0 0 0 2 31.4v25.2A2.4 2.4 0 0 0 4.4 59h43.2a2.4 2.4 0 0 0 2.4-2.4V31.4a2.4 2.4 0 0 0-2.4-2.4zM12 53h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm10 0h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm2-8H10a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm8 8h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm10 0h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm0-14h-6a2 2 0 0 1 0-4h6a2 2 0 0 1 0 4z",
    fill: "#8d8ea3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M61.9 30.6l-8.7-24a2.4 2.4 0 0 0-3.1-1.4L9.6 19.9A2.4 2.4 0 0 0 8.2 23l.7 2H13L54.4 9.9l1.4 3.8L24.7 25h22.9a6.4 6.4 0 0 1 6.4 6.4V36l6.4-2.3a2.4 2.4 0 0 0 1.5-3.1zm-10-8.7l-4.5 1.6h-.7a2 2 0 0 1-.7-3.9l4.5-1.6a2 2 0 1 1 1.4 3.8z",
    fill: "#253858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank2);
export default __webpack_public_path__ + "static/media/bank2.e9ffda895a9d4cf91881f60198877de0.svg";
export { ForwardRef as ReactComponent };